<script setup>
import { ref, onBeforeMount,onMounted } from 'vue'
import Swal from 'sweetalert2'
import api from '@/api'
import { useStore } from "vuex";
const store = useStore();
const identificacion = ref('')
const cargando = ref(false)
const formulario = ref(null)
const inputIdentificacion = ref(null)

const registrarAsistencia = async () => {
  if (!identificacion.value.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Campo requerido',
      text: 'Debes ingresar tu número de identificación.',
      timer: 2000,
      showConfirmButton: false,
      didClose: () => {
        formulario.value?.reset()
        identificacion.value = ''
        inputIdentificacion.value?.focus()
      }
    })
    return
  }

  cargando.value = true

  try {
    const response = await api.post('/accesos/publico', {
      identificacion: identificacion.value.trim()
    })

    Swal.fire({
      icon: 'success',
      title: 'Éxito',
      text: `Asistencia registrada para ${response.data.acceso.usuario_id}`,
      timer: 2500,
      showConfirmButton: false,
      didClose: () => {
        formulario.value?.reset()
        identificacion.value = ''
        inputIdentificacion.value?.focus()
      }
    })
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error(error)
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error?.response?.data?.message || 'No se pudo registrar la asistencia.',
      timer: 3000,
      showConfirmButton: false,
      didClose: () => {
        formulario.value?.reset()
        identificacion.value = ''
        inputIdentificacion.value?.focus()
      }
    })
  } finally {
    cargando.value = false
  }
}

onMounted(() => {
  inputIdentificacion.value?.focus()
})
onBeforeMount(() => {


  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  store.state.isTransparent = "bg-white";
});
</script>

<template>
  <div class="mx-3 mt-4 border-radius-xl d-flex align-items-center justify-content-center" style="min-height: 100vh"
    :style="{
      backgroundImage: 'url(' + require('@/assets/img/gimnasio.webp') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }">
    <div class="card p-5 shadow-lg" style="max-width: 400px; width: 100%">
      <h4 class="text-center mb-4">Registra tu Asistencia</h4>
      <form @submit.prevent="registrarAsistencia" ref="formulario">
        <div class="form-group">
          <label for="codigo">Código de Socio</label>
          <input v-model="identificacion" type="text" class="form-control mb-3" placeholder="Ingresa tu identificación"
            @keyup.enter="registrarAsistencia" :disabled="cargando"  ref="inputIdentificacion" />
        </div>
        <button class="btn btn-success w-100" @click="registrarAsistencia" :disabled="cargando">
          Registrar Asistencia
        </button>

      </form>
    </div>
  </div>
</template>
